module.exports = __webpack_public_path__ + "img/东南大学.99268d86.png";